export default __webpack_public_path__ + "static/media/EM0800.34I-22033_-15030_0.1db0f39f.jpg";